<template>
  <v-container fluid>
    <v-card class="pl-6 pr-6 pt-6 pb-6">
      <v-card-title>
        <v-row>
          <v-col cols="6" md="6" justify="center">
            <h3>Patent Matter Edit</h3>
          </v-col>
          <v-col cols="6" md="6"></v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row justify="space-between" class="mt-hf">
          <v-col cols="12" sm="7" md="7" style="margin-top: 14px">
            <v-row class="mt-h">
              <v-col cols="12" sm="6" md="6">
                <h3><span class="vali">*</span>Object Type</h3>
                <v-autocomplete v-model="itemdata.tm_type" :items="objecttype_list" item-text="objecttype_code"
                  item-value="objecttype_id" outlined dense></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <h3>Country</h3>
                <v-autocomplete clearable @click:clear="
                  $nextTick(() => {
                    itemdata.city = 0;
                  })
                  " v-model="itemdata.city" :items="country_list" item-text="enname" item-value="enname" outlined
                  @change="onSelectCountryChange(showaddItem.country)" dense></v-autocomplete>
              </v-col>
            </v-row>
            <v-row class="mt-h">
              <v-col cols="12" sm="4" md="4">
                <h3>Application No.</h3>
                <v-text-field v-model="itemdata.app_no" outlined dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <h3>Application Date</h3>
                <v-menu v-model="menuaddAppD" :close-on-content-click="false" :nudge-right="40"
                  transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="itemdata.date_of_application" persistent-hint hint="Format DD/MM/YYYY"
                      @keydown.enter="
                        date_of_application = parseDate(
                          itemdata.date_of_application
                        )
                        " @blur="
                          date_of_application = parseDate(
                            itemdata.date_of_application
                          )
                          " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense clearable @click:clear="
                            $nextTick(() => {
                              itemdata.date_of_application = null;
                            })
                            "></v-text-field>
                  </template>
                  <v-date-picker v-model="date_of_application" @input="menuaddAppD = false"
                    @change="onApplicationDateChanged"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="4" md="4" />
            </v-row>
            <v-row class="mt-h">
              <v-col cols="12" sm="4" md="4">
                <h3><span class="vali">*</span>File No. (PF-0000)</h3>
                <v-text-field v-model="itemdata.file_no" outlined dense disabled
                  background-color="#F5F5F5"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <h3>Type</h3>
                <v-autocomplete clearable @click:clear="
                  $nextTick(() => {
                    itemdata.type = 0;
                  })
                  " v-model="itemdata.type" :items="type_list" item-text="type_name" item-value="type_number" outlined
                  dense></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <h3>Sub Type</h3>
                <v-autocomplete clearable @click:clear="
                  $nextTick(() => {
                    itemdata.sub_type = '';
                  })
                  " v-model="itemdata.sub_type" :items="subtype_list" outlined dense></v-autocomplete>
                <v-text-field v-if="itemdata.sub_type == 'Other'" v-model="other_sub" outlined dense
                  label="Other"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="mt-h">
              <v-col cols="12" sm="12" md="12">
                <h3>Title</h3>
                <v-text-field v-model="itemdata.title" outlined dense></v-text-field>
              </v-col>
            </v-row>
            <v-row class="mt-h">
              <v-col cols="12" sm="12" md="12">
                <h3>Title in Thai</h3>
                <v-text-field v-model="itemdata.good_service" outlined dense></v-text-field>
              </v-col>
            </v-row>
            <v-row style="margin: 12px 0px 0px 0px">
              <div justify="space-center" class="pt-10 pb-4 pl-8"
                style="border: 1px solid #ccc; border-radius: 8px; width: 100%">
                <v-row class="mt-h" v-for="(priority, index) in priorityList" :key="index">
                  <v-col cols="12" sm="10" md="10">
                    <v-row>
                      <v-col cols="12" sm="4" md="4">
                        <h3 v-if="index == 0">Priority Number</h3>
                        <v-text-field v-model="priority.number" outlined dense />
                      </v-col>
                      <v-col cols="12" sm="4" md="4">
                        <h3 v-if="index == 0">Priority Date</h3>
                        <v-menu v-model="priority.menu" :close-on-content-click="false" :nudge-right="40"
                          transition="scale-transition" offset-y min-width="auto">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field :value="formatDatePriority(priority.date)" persistent-hint
                              hint="Format DD/MM/YYYY" append-icon="mdi-calendar" @keydown.enter="
                                priority.date = parseDateInputPriority(
                                  priority.date
                                )
                                " @blur="
                                  priority.date = parseDateInputPriority(
                                    priority.date
                                  )
                                  " v-bind="attrs" v-on="on" outlined dense clearable></v-text-field>
                          </template>
                          <v-date-picker v-model="priority.date" @input="priority.menu = false"></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" sm="4" md="4">
                        <h3 v-if="index == 0">Priority Country</h3>
                        <!-- <v-text-field v-model="priority.country" outlined dense /> -->
                        <v-autocomplete clearable @click:clear="
                          $nextTick(() => {
                            priority.country = 0;
                          })
                          " v-model="priority.country" :items="country_list" item-text="enname" item-value="enname"
                          outlined dense></v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" sm="2" md="2" class="d-flex align-center" style="padding-left: 30px">
                    <v-icon @click="addPriority" class="bt-add" :style="{ marginTop: index > 0 ? '-25px' : 'none' }">
                      mdi-plus
                    </v-icon>
                    <v-icon @click="removePriority(index)" v-if="priorityList.length > 1" class="bt-del"
                      :style="{ marginTop: index > 0 ? '-25px' : 'none' }">
                      mdi-minus
                    </v-icon>
                  </v-col>
                </v-row>
                <v-row style="margin-top: -10px" v-if="itemdata.sub_type == 'PCT'">
                  <v-col cols="12" sm="10" md="10">
                    <v-row>
                      <v-col cols="12" sm="6" md="6">
                        <h3>
                          <span class="vali">*</span>International Filing Number
                        </h3>
                        <v-text-field v-model="itemdata.international_filing_number" outlined dense />
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <h3>
                          <span class="vali">*</span>International Filing Date
                        </h3>
                        <v-menu v-model="menuInterNew" :close-on-content-click="false" :nudge-right="40"
                          transition="scale-transition" offset-y min-width="auto">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="itemdata.international_filing_date" persistent-hint
                              hint="Format DD/MM/YYYY" @keydown.enter="
                                international_filing_date = parseDate(
                                  itemdata.international_filing_date
                                )
                                " @blur="
                                  international_filing_date = parseDate(
                                    itemdata.international_filing_date
                                  )
                                  " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense
                              clearable></v-text-field>
                          </template>

                          <v-date-picker v-model="international_filing_date"
                            @input="menuInterNew = false"></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
            </v-row>
            <!-- <v-row style="margin-top: 35px;">
                <v-col cols="12" sm="4" md="4">
                    <h3>Publication Date</h3>
                    <v-menu
                      v-model="menuaddpubd"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="itemdata.date_of_publishing"
                          persistent-hint
                          hint="Format DD/MM/YYYY"
                          @keydown.enter="
                            date_of_publishing = parseDate(
                              itemdata.date_of_publishing
                            )
                          "
                          @blur="
                            date_of_publishing = parseDate(
                              itemdata.date_of_publishing
                            )
                          "
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          dense
                          clearable
                        ></v-text-field>
                      </template>

                      <v-date-picker
                        v-model="date_of_publishing"
                        @input="menuaddpubd = false"
                      ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <h3>Vol. No.</h3>
                    <v-text-field
                        v-model="itemdata.val_no"
                        outlined
                        dense
                    ></v-text-field>
                </v-col>
          
                <v-col cols="12" sm="4" md="4">
                    <h3>Page No.</h3>
                    <v-text-field
                        v-model="itemdata.page_no"
                        outlined
                        dense
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row class="mt-h">
                <v-col cols="12" sm="6" md="6">
                    <h3>Sub Exam Request Deadline Date</h3>
                    <v-menu
                      v-model="menuadderdd"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="itemdata.exam_request_deadline"
                          persistent-hint
                          hint="Format DD/MM/YYYY"
                          @keydown.enter="
                            exam_request_deadline = parseDate(
                              itemdata.exam_request_deadline
                            )
                          "
                          @blur="
                            exam_request_deadline = parseDate(
                              itemdata.exam_request_deadline
                            )
                          "
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          dense
                          clearable
                        ></v-text-field>
                      </template>

                      <v-date-picker
                        v-model="exam_request_deadline"
                        @input="menuadderdd = false"
                      >
                      </v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                    <h3>Sub Exam Request Date</h3>
                    <v-menu
                      v-model="menuadderd"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="itemdata.exam_request_date"
                          persistent-hint
                          hint="Format DD/MM/YYYY"
                          @keydown.enter="
                            exam_request_date = parseDate(itemdata.exam_request_date)
                          "
                          @blur="
                            exam_request_date = parseDate(itemdata.exam_request_date)
                          "
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          dense
                          clearable
                        ></v-text-field>
                      </template>

                      <v-date-picker
                        v-model="exam_request_date"
                        @input="menuadderd = false"
                      >
                      </v-date-picker>
                    </v-menu>
                </v-col>
            </v-row> -->
          </v-col>
          <v-col cols="12" sm="5" md="5">
            <v-row style="margin-top: 10px">
              <v-col cols="12" sm="4" md="4" align="right">
                <h3><span class="vali">*</span>Client Name</h3>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-autocomplete v-model="owner_contact_list" :items="contact_owner_list" item-text="contact_name"
                  item-value="contact_id" clearable multiple outlined dense return-object @click:clear="
                    $nextTick(() => {
                      owner_contact_list = [];
                      owner_address = '';
                    })
                    " @change="onSelectOwnerChange()">
                  <!-- Slot to display checkbox -->
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="item" small>
                      {{ item.contact_name }}
                    </v-chip>
                  </template>

                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item v-bind="attrs" v-on="on">
                      <v-list-item-action>
                        <v-checkbox :input-value="owner_contact_list.includes(item)" />
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title v-text="item.contact_name" />
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row style="margin-top: -25px">
              <v-col cols="12" sm="4" md="4" class="d-flex align-start justify-end">
                <h3>Client Address</h3>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-card class="text-field-style scrollable-card" outlined dense>
                  <div v-if="owner_contact_list.length > 0" v-for="(item, index) in owner_contact_list" :key="index"
                    :style="{
                      paddingTop: '7px',
                      lineHeight: '1.2',
                      paddingBottom:
                        index == owner_contact_list.length - 1 ? '7px' : '0',
                    }">
                    <span><b>{{ item.contact_name }}: </b>
                      {{ item.owner_address }}</span><br />
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <v-row style="margin-top: -18px">
              <v-col cols="12" sm="4" md="4" class="d-flex align-start justify-end">
                <h3>Agent Reference</h3>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-text-field v-model="itemdata.client_ref" outlined dense></v-text-field>
              </v-col>
            </v-row>
            <v-row style="margin-top: 10px">
              <v-col cols="12" sm="4" md="4" align="right">
                <h3>Agent</h3>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-autocomplete clearable @click:clear="
                  $nextTick(() => {
                    itemdata.agent_contact = 0;
                    agent_address = '';
                  })
                  " v-model="itemdata.agent_contact" :items="contact_agent_list" item-text="contact_name"
                  item-value="contact_id" outlined dense
                  @change="onSelectAgentChange(itemdata.agent_contact)"></v-autocomplete>
              </v-col>
            </v-row>
            <v-row style="margin-top: -40px">
              <v-col cols="12" sm="4" md="4" class="d-flex align-start justify-end" style="margin-top: 10px">
                <h3>Agent Email</h3>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-text-field v-model="itemdata.agent_email" outlined dense background-color="#F5F5F5"
                  disabled></v-text-field>
              </v-col>
            </v-row>
            <v-row style="margin-top: -25px">
              <v-col cols="12" sm="4" md="4" align="right">
                <h3>Agent Address</h3>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-textarea class="mt-detail" v-model="agent_address" multi-line outlined dense
                  background-color="#F5F5F5" disabled rows="3"></v-textarea>
              </v-col>
            </v-row>
            <v-row style="margin-top: -25px">
              <v-col cols="12" sm="4" md="4" align="right">
                <h3>Associate</h3>
                <h3>(Oversea)</h3>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-autocomplete clearable @click:clear="
                  $nextTick(() => {
                    itemdata.associate_contact = 0;
                    associate_address = '';
                  })
                  " v-model="itemdata.associate_contact" :items="contact_associate_list" item-text="contact_name"
                  item-value="contact_id" outlined dense
                  @change="onSelectAssociateChange(itemdata.associate_contact)"></v-autocomplete>
              </v-col>
            </v-row>
            <v-row style="margin-top: -25px">
              <v-col cols="12" sm="4" md="4" align="right">
                <h3>Associate Address</h3>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-textarea class="mt-detail" v-model="associate_address" multi-line outlined dense
                  background-color="#F5F5F5" disabled rows="3"></v-textarea>
              </v-col>
            </v-row>

            <v-row style="margin-top: -18px">
              <v-col cols="12" sm="4" md="4" align="right">
                <h3>Billing To</h3>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-autocomplete clearable @click:clear="
                  $nextTick(() => {
                    customer_selected = null;
                    customer_address = '';
                  })
                  " v-model="customer_selected" :items="customer_list" item-text="name" item-value="id" outlined
                  @change="onSelectComboboxMetterChange(customer_selected)" dense></v-autocomplete>
              </v-col>
            </v-row>
            <v-row style="margin-top: -40px">
              <v-col cols="12" sm="4" md="4" align="right" style="margin-top: 10px">
                <h3>Billing Address</h3>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-textarea v-model="customer_address" multi-line outlined dense background-color="#F5F5F5"
                  disabled></v-textarea>
              </v-col>
            </v-row>
            <v-row style="margin-top: -18px">
              <v-col cols="12" sm="4" md="4" align="right" class="mt-2">
                <h3>Send Billing To</h3>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-autocomplete clearable @click:clear="
                  $nextTick(() => {
                    sendBilling = null;
                    sendBillingDetail = '';
                  })
                  " v-model="sendBilling" :items="sendBillingList" outlined dense></v-autocomplete>
              </v-col>
            </v-row>
            <v-row style="margin-top: -40px">
              <v-col cols="12" sm="4" md="4" align="right" class="mt-2" />
              <v-col cols="12" sm="8" md="8">
                <v-text-field v-if="
                  sendBilling == 'Link' || sendBilling == 'Specific Email'
                " v-model="sendBillingDetail" outlined dense></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row style="margin-top: 10px">
          <v-col cols="12" sm="3" md="3">
            <h3>Publication Date</h3>
            <v-menu v-model="menuaddpubd" :close-on-content-click="false" :nudge-right="40"
              transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="itemdata.date_of_publishing" persistent-hint hint="Format DD/MM/YYYY"
                  @keydown.enter="
                    date_of_publishing = parseDate(itemdata.date_of_publishing)
                    " @blur="
                      date_of_publishing = parseDate(itemdata.date_of_publishing)
                      " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense clearable></v-text-field>
              </template>

              <v-date-picker v-model="date_of_publishing" @input="menuaddpubd = false"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3>Vol. No.</h3>
            <v-text-field v-model="itemdata.val_no" outlined dense></v-text-field>
          </v-col>

          <v-col cols="12" sm="3" md="3">
            <h3>Page No.</h3>
            <v-text-field v-model="itemdata.page_no" outlined dense></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mt-h">
          <v-col cols="12" sm="3" md="3">
            <h3>Sub Exam Request Deadline Date</h3>
            <v-menu v-model="menuadderdd" :close-on-content-click="false" :nudge-right="40"
              transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="itemdata.exam_request_deadline" persistent-hint hint="Format DD/MM/YYYY"
                  @keydown.enter="
                    exam_request_deadline = parseDate(
                      itemdata.exam_request_deadline
                    )
                    " @blur="
                      exam_request_deadline = parseDate(
                        itemdata.exam_request_deadline
                      )
                      " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense clearable></v-text-field>
              </template>

              <v-date-picker v-model="exam_request_deadline" @input="menuadderdd = false">
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3>Sub Exam Request Date</h3>
            <v-menu v-model="menuadderd" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
              offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="itemdata.exam_request_date" persistent-hint hint="Format DD/MM/YYYY"
                  @keydown.enter="
                    exam_request_date = parseDate(itemdata.exam_request_date)
                    " @blur="
                      exam_request_date = parseDate(itemdata.exam_request_date)
                      " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense clearable></v-text-field>
              </template>

              <v-date-picker v-model="exam_request_date" @input="menuadderd = false">
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3>Patent No.</h3>
            <v-text-field v-model="itemdata.patent_no" outlined dense></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3>Patent Date</h3>
            <v-menu v-model="menuaddptd" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
              offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="itemdata.date_of_patent" persistent-hint hint="Format DD/MM/YYYY" @keydown.enter="
                  date_of_patent = parseDate(itemdata.date_of_patent)
                  " @blur="date_of_patent = parseDate(itemdata.date_of_patent)" append-icon="mdi-calendar"
                  v-bind="attrs" v-on="on" outlined dense clearable></v-text-field>
              </template>

              <v-date-picker v-model="date_of_patent" @input="menuaddptd = false"></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row justify="space-around" style="margin-top: -25px">
          <v-col cols="12" sm="2" md="2">
            <h3>Last Annuity Payment</h3>
            <v-autocomplete clearable @click:clear="
              $nextTick(() => {
                itemdata.dead_last_annuity_paid = '';
              })
              " v-model="itemdata.dead_last_annuity_paid" :items="latest_list" outlined dense
              @input="onApplicationDateChanged"></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3>Date Of The Last Annuity Payment</h3>
            <v-menu v-model="menuaddlapd" :close-on-content-click="false" :nudge-right="40"
              transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="itemdata.last_annuity_paid" persistent-hint hint="Format DD/MM/YYYY"
                  @keydown.enter="
                    last_annuity_paid = parseDate(itemdata.last_annuity_paid)
                    " @blur="
                      last_annuity_paid = parseDate(itemdata.last_annuity_paid)
                      " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense clearable></v-text-field>
              </template>

              <v-date-picker v-model="last_annuity_paid" @input="menuaddlapd = false">
              </v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" sm="1" md="1"></v-col>
          <v-col cols="12" sm="3" md="3">
            <h3>Next Payment Due Date</h3>
            <v-menu v-model="menuaddnad" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
              offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="itemdata.next_annuity_date" persistent-hint hint="Format DD/MM/YYYY"
                  @keydown.enter="
                    next_annuity_date = parseDate(itemdata.next_annuity_date)
                    " @blur="
                      next_annuity_date = parseDate(itemdata.next_annuity_date)
                      " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense clearable></v-text-field>
              </template>

              <v-date-picker v-model="next_annuity_date" @input="
                () => {
                  menuaddnad = false;
                  updateFinalDueDateFromNextAnnuity();
                }
              ">
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3>Final Due Date For Next Payment</h3>
            <v-menu v-model="menuaddnadfinalDatePayment" :close-on-content-click="false" :nudge-right="40"
              transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="itemdata.final_due_date_for_next_payment" persistent-hint
                  hint="Format DD/MM/YYYY" @keydown.enter="
                    final_due_date_for_next_payment = parseDate(
                      itemdata.final_due_date_for_next_payment
                    )
                    " @blur="
                      final_due_date_for_next_payment = parseDate(
                        itemdata.final_due_date_for_next_payment
                      )
                      " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense clearable></v-text-field>
              </template>

              <v-date-picker v-model="final_due_date_for_next_payment" @input="menuaddnadfinalDatePayment = false">
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <!-- <v-row justify="space-around" >
          <v-col cols="12" sm="5" md="5">
            <h3>Next Renewal D/L</h3>

                    <v-menu
                        v-model="menuaddnrd"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="itemdata.next_renewal"
                            persistent-hint
                            hint="Format DD/MM/YYYY"
                            @keydown.enter="
                              next_renewal = parseDate(itemdata.next_renewal)
                            "
                            @blur="next_renewal = parseDate(itemdata.next_renewal)"
                            append-icon="mdi-calendar"
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            dense
                            clearable
                          ></v-text-field>
                        </template>

                        <v-date-picker
                          v-model="next_renewal"
                          @input="menuaddnrd = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
          <v-col cols="12" sm="1" md="1"></v-col>
          <v-col cols="12" sm="6" md="6">
          </v-col>
        </v-row> -->
        <v-row justify="space-around" style="margin-top: -25px">
          <v-col cols="12" sm="3" md="3">
            <h3>Patent Status</h3>
            <v-autocomplete :disable="disabled_status" clearable @click:clear="
              $nextTick(() => {
                itemdata.status = 0;
              })
              " v-model="itemdata.status" :items="patent_status_list" item-text="patent_status_name"
              item-value="patent_status_id" outlined dense></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="9" md="9">
            <h3>Remark</h3>
            <v-textarea v-model="itemdata.remark" multi-line outlined dense rows="3"></v-textarea>
          </v-col>
        </v-row>

        <v-row justify="space-around">
          <v-col cols="12" sm="12" md="12">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <h3>
                  Upload File
                  <span class="red--text">(Support .pdf files only) </span>
                </h3>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="12" style="margin-top: -15px">
            <v-row align="start">
              <v-col cols="4" sm="4" md="3">
                <input type="file" accept="application/pdf,application/vnd.ms-excel" multiple="multiple"
                  @change="previewMultiImageEdit" class="inputsize" ref="filefile" style="display: none" />
                <v-btn :style="{
                  backgroundColor: '#254E58',
                  color: 'white',
                  width: '100%',
                }" class="widthbtnimagefile" @click="$refs.filefile.click()" elevation="7">
                  <v-icon left dark color="white"> mdi-cloud-upload </v-icon>Upload file</v-btn>
              </v-col>
              <v-col cols="1" sm="1" md="1" />
              <v-col cols="7" sm="7" md="8" class="mt-4">
                <v-row v-for="(item, index) in filename" :key="index">
                  <span @click="popuppreviewfile(index)" class="file-link">
                    {{ item.name }}
                  </span>
                  <v-btn icon color="red" @click="popupdeletefile(index)" style="margin-top: -7px">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <!-- <v-col cols="12" sm="12" md="12">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <h3>
                  Upload Image
                  <span class="red--text"> (Support .jpeg .png)</span>
                </h3>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="12" style="margin-top: -15px;">
            <v-row align="start">
              <v-col cols="4" sm="4" md="3">
                <input
                  type="file"
                  accept="image/.png.jpg"
                  @change="previewImageEdit"
                  class="inputsize"
                  ref="fileimage"
                  style="display: none"
                />
                <v-btn
                  :style="{
                    backgroundColor: '#254E58',
                    color: 'white',
                    width: '100%'
                  }"
                  class="widthbtnimagefile"
                  @click="$refs.fileimage.click()"
                  elevation="7"
                >
                  <v-icon left dark color="white"> mdi-cloud-upload </v-icon
                  >Upload Image</v-btn
                >
              </v-col>
              <v-col cols="1" sm="1" md="1" />
              <v-col cols="7" sm="7" md="8"  class="mt-4">
                <v-row v-if="imagenameedit != ''"> 
                  <span 
                    @click="popuppreviewimage()"
                    class="file-link"
                  >
                    {{ imagenameedit }}
                  </span>  
                  <v-btn
                    icon
                    color="red"
                    @click="popupdeleteimage()"
                    style="margin-top: -7px;"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-col> -->

          <v-col cols="12" sm="2" md="2" align="right"> </v-col>
          <v-col cols="12" sm="5" md="5"> </v-col>
        </v-row>
        <v-row justify="space-around" style="margin-top: -20px; margin-bottom: 20px">
          <v-col cols="12" sm="12" md="12">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <h3>
                  Upload Certificate
                  <span class="red--text">(Support .pdf files only) </span>
                </h3>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="12" style="margin-top: -15px">
            <v-row align="start">
              <v-col cols="4" sm="4" md="3">
                <input type="file" accept="application/pdf,application/vnd.ms-excel" multiple="multiple"
                  @change="previewMultiImage_cer" class="inputsize" ref="file_cer" style="display: none" />
                <v-btn :style="{
                  backgroundColor: '#254E58',
                  color: 'white',
                  width: '100%',
                }" class="widthbtnimagefile" @click="$refs.file_cer.click()" elevation="7">
                  <v-icon left dark color="white"> mdi-cloud-upload </v-icon>
                  Upload file
                </v-btn>
              </v-col>
              <v-col cols="1" sm="1" md="1" class="text-right mt-1"> </v-col>
              <v-col cols="7" sm="7" md="8" class="mt-4">
                <v-row v-for="(item_cer, index_cer) in image_list_cer" :key="index_cer">
                  <span @click="popuppreviewfile_cer(index_cer)" class="file-link">
                    {{ item_cer.name }}
                  </span>
                  <v-btn icon color="red" @click="popupdeletefile_cer(index_cer)" style="margin-top: -7px">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <!--   :href="`/timeline-master-patent/${this.$route.params.masterpt_id}`"
                    target="_blank" -->
            <v-btn class="mr-3" :style="{
              backgroundColor: '#808080',
              color: 'white',
            }" @click="openhideshowtimeline()">
              Matter Timeline All Docket
            </v-btn>
            <!-- <v-btn
                    class="mr-3"
                    :style="{
                    backgroundColor: '#808080',
                    color: 'white',
                    }"
                    @click="openTimeline()"
                >
                    TimeLine Popup
                </v-btn> -->
            <!-- <v-btn
                  :style="{
                    backgroundColor: '#808080',
                    color: 'white',
                  }"
                  @click="openhideshowlistofrecord"
                  elevation="7"
                >
                  <v-icon left dark color="white"> mdi-file-multiple </v-icon>All
                  records
                </v-btn> -->
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <div v-if="disablebtnappointmenttimeline">
              <div class="mt-6">
                <v-card-title class="text-h4 black--text">Matter Timeline All Docket</v-card-title>
                <!-- <v-card outlined tile> -->
                <v-timeline dense v-if="showtimelineData.length > 0">
                  <v-timeline-item v-for="item in showtimelineData" :key="item.id" color="primary" small>
                    <v-card class="pa-3">
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <div>{{ item.show_date }}</div>
                          <br />
                          <div style="margin-top: -20px">
                            {{
                              item.documenttype_code
                                ? item.documenttype_code
                                : ""
                            }}
                          </div>
                          <!-- {{ JSON.parse(item.documenttype_actions)[0]?JSON.parse(item.documenttype_actions)[0].documenttype_code:"" }} -->
                          <div v-for="datadocumenttype_actions in JSON.parse(
                            item.documenttype_actions
                          )" style="font-size: 0.8rem; color: gray">
                            - {{ datadocumenttype_actions.name }}
                          </div>
                        </v-col>
                        <v-col cols="12" sm="5" md="5">
                          <v-row style="margin-top: -10px">
                            <v-col cols="12" sm="6" md="6">
                              <div class="d-flex" style="font-size: 0.7rem; color: blue">
                                <span v-if="
                                  item.fullnameen_user_update ||
                                  item.fullnameth_user_update
                                ">Last Updated {{ item.updated_date }}</span>
                                <span v-else>Last Updated -</span>
                              </div>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <div class="d-flex" style="font-size: 0.7rem; color: blue">
                                <span v-if="
                                  item.fullnameen_user_update ||
                                  item.fullnameth_user_update
                                ">Last Update By
                                  {{
                                    item.fullnameen_user_update
                                      ? item.fullnameen_user_update
                                      : item.fullnameth_user_update
                                        ? item.fullnameth_user_update
                                        : ""
                                  }}</span>
                                <span v-else>Last Update By -</span>
                              </div>
                            </v-col>
                          </v-row>
                          <v-row style="margin-top: -25px">
                            <v-col cols="12" sm="6" md="6">
                              <div class="d-flex" style="font-size: 0.7rem; color: blue">
                                <span v-if="item.created_date">Created Date {{ item.created_date }}</span>
                                <span v-else>Created Date -</span>
                              </div>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <div class="d-flex" style="font-size: 0.7rem; color: blue">
                                <span v-if="
                                  item.fullnameen_user_create ||
                                  item.fullnameth_user_create
                                ">Create By
                                  {{
                                    item.fullnameen_user_create
                                      ? item.fullnameen_user_create
                                      : item.fullnameth_user_create
                                        ? item.fullnameth_user_create
                                        : ""
                                  }}</span>
                                <span v-else>Create By -</span>
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12" sm="1" md="1" class="d-flex align-center justify-center">
                          <template>
                            <v-btn icon outlined color="primary" small @click="editItemtimeline(item)">
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-timeline-item>
                </v-timeline>
                <v-timeline dense v-else>
                  <v-timeline-item>
                    <v-card class="pa-3">
                      <v-row>
                        <v-col cols="12" sm="7" md="7">
                          <div>No Date</div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-timeline-item>
                </v-timeline>
                <!-- </v-card> -->
              </div>
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <div v-if="!disablebtnappointmentallrecord">
              <div v-if="hideshowlistofrecord" class="mt-6">
                <v-card-title class="text-h4 black--text">Docket Chronicle List</v-card-title>
                <v-card outlined tile>
                  <v-data-table :headers="headers" :items="mDataArrayappointment" class="elevation-1">
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-icon class="ml-1" :style="{
                        backgroundColor: '#E1F5FE',
                        color: '#2196F3',
                      }" @click="openeditItemAppointment(item.appointment_id)">
                        mdi-pencil
                      </v-icon>
                    </template>
                  </v-data-table>
                </v-card>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions v-if="!disabled_status">
        <v-spacer></v-spacer>
        <v-btn depressed class="mr-3 buttongold" @click="saveItem('createAp')">
          Save and create Docket
        </v-btn>
        <v-btn @click="saveItem('createPT')" width="100" class="mr-3 buttonblue" color="#112D32">
          Save
        </v-btn>
        <v-btn to="/master-patent-list" depressed outlined width="100">
          Cancel
        </v-btn>
        <v-spacer></v-spacer>
        <br />
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Are you sure you want to delete this file?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDeleteimage" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Are you sure you want to delete this image?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDeleteimage">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirmimage">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogpreviewfile" max-width="700px">
      <v-card>
        <v-card-title class="text-h5">
          <v-btn icon @click="closepreviewfile">
            <v-icon large>mdi-close</v-icon>
          </v-btn>
          Preview PDF File</v-card-title>

        <!-- 
                               :src="pdfdata"
                              v-for="i in numPages"
                  :key="i"
                  :id="i"
                  :page="i" -->
        <div v-if="checkfileapreview" v-for="(item, index) in previewpopupfile2" :key="index">
          <pdf :src="item" v-for="i in numPagespreview" :key="i" :id="i" :page="i">
            <template slot="loading"> loading content here... </template>
          </pdf>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closepreviewfile">Cancel</v-btn>

          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogpreviewimage" max-width="700px">
      <v-card>
        <v-card-title class="text-h5">
          <v-btn icon @click="closepreviewimage">
            <v-icon large>mdi-close</v-icon>
          </v-btn>
          Preview Image</v-card-title>

        <v-img disabled :src="previewimageedit" class="grey lighten-2 mt-3 mb-5" aspect-ratio="1" contain>
        </v-img>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closepreviewimage">Cancel</v-btn>

          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogTimeline" max-width="600px">
      <v-card>
        <v-card-title>
          Matter Timeline All Docket Detail
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogTimeline = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-timeline dense>
            <v-timeline-item v-for="item in timelineData" :key="item.id" color="primary" small>
              <v-card class="pa-3 mr-10">
                <div>
                  <h3 style="color: #b6272b">{{ item.update_date }}</h3>
                </div>
                <div v-if="item.file_type == 'image'" style="font-size: 0.8rem" class="file-link"
                  @click="popuppreviewImageTable(item.file_name)">
                  {{ item.file_name }}
                </div>
                <div v-else style="font-size: 0.8rem" class="file-link" @click="popuppreviewfileTable(item.file_name)">
                  {{ item.file_name }}
                </div>
              </v-card>
            </v-timeline-item>
          </v-timeline>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete_cer" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Are you sure you want to delete this file?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete_cer">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm_cer">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />
    <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message" :link="link" />
  </v-container>
</template>

<script>
const moment = require("moment-timezone");
import {
  server,
  imagemasterPTUrl,
  filemasterPTUrl,
} from "@/services/constants";
import api from "@/services/api";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import pdfvuer from "pdfvuer";

export default {
  name: "MasterPatentAdd",
  components: { SuccessDialog, SuccessDialogPush, pdf: pdfvuer },
  data() {
    return {
      sendBilling: "Reply All",
      sendBillingList: ["Reply All", "Specific Email", "Link"],
      sendBillingDetail: "",
      customer_list: [],
      customer_selected: null,
      customer_address: "",

      removed_cer_files: [],
      fileindex_cer: -1,
      preview_list_cer: [],
      image_list_cer: [],
      filename_cer: [],
      getpreview_list_cer: [],
      preview_list2_cer: [],
      checkfileeadd_cer: false,
      dialogDelete_cer: false,

      owner_contact_list: [],
      owner_address: "",
      associate_address: "",
      agent_address: "",
      priorityListOld: [],
      priorityList: [
        {
          id: 0,
          number: "",
          date: "",
          country: "",
          menu: false,
        },
      ],

      other_sub: "",
      subtype_list: ["PARIS", "PCT", "Other"],
      showtimelineData: [],
      timelineData: [
        // { id: 1, event: "Start Project", date: "18/06/2025" },
        // { id: 2, event: "Design Phase", date: "19/06/2025"},
        // { id: 3, event: "Development Phase", date: "23/06/2025"},
        // { id: 4, event: "Testing", date: "28/06/2025"},
        // { id: 5, event: "Deployment", date: "03/07/2025"},
      ],
      preview_list2: [],
      mDataArrayappointment: [],
      hideshowlistofrecord: false,
      disablebtnappointmenttimeline: false,
      disablebtnappointmentallrecord: false,
      getpreview_list: [],
      image: null,
      previewimage: null,
      previewimageedit: null,
      image_list: [],
      preview_list: [],
      dialogpreviewimage: false,
      checkfileapreview: false,
      previewpopupfile: [],
      previewpopupfile2: [],
      dialogpreviewfile: false,
      dialogDelete: false,
      dialogDeleteimage: false,
      filename: [],
      oldfilename: [],
      imagename: "",
      load_bg: false,
      checkfileadd: false,
      checkimageadd: false,
      filenameedit: [],
      imagenameedit: "",
      getcurrentimage: "",
      getoldimage: "",
      getcurrentfilename: [],
      getoldfilename: [],
      oldpdffiles: [],
      fileindex: -1,
      checkfileedit: false,
      checkimageedit: false,
      page: 1,
      numPages: 0,
      numPagespreview: 0,
      pdfdata: undefined,
      errors: [],
      scale: "page-width",
      dialogEditmastertm: false,
      image_listedit: [],
      getpreview_listedit: [],
      preview_listedit: [],
      preview_listedit2: [],

      country_list: [],
      isShowPassword: false,
      fullPage: true,
      objecttype_list: [],
      contact_owner_list: [],
      contact_agent_list: [],
      contact_associate_list: [],
      menuadd: false,
      menuaddAppD: false,
      menuaddptd: false,
      menuaddpubd: false,
      menuadderdd: false,
      menuaddeaxmd: false,
      menuadderd: false,
      menuaddlapd: false,
      menuaddnad: false,
      menuaddnadfinalDatePayment: false,
      menuaddnrd: false,
      menuaddlra: false,
      menuaddndd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      dialogAdd: false,
      main_id: 0,
      mode_operation: "Create",
      date_of_application: null,
      date_of_patent: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      date_of_publishing: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      exam_request_date: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      exam_request_deadline: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      date_of_examination: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      next_deadline: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      last_annuity_paid: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      next_annuity_date: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      final_due_date_for_next_payment: null,
      next_renewal: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      last_renewal_att: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      type_list: [
        { type_name: "Design", type_number: "1" },
        { type_name: "Invention", type_number: "2" },
        { type_name: "Petty", type_number: "3" },
      ],
      // eslint-disable-next-line prettier/prettier
      latest_list: [
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
      ],
      menuInterNew: false,
      international_filing_date: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      patent_status_list: [
        {
          patent_status_name: "Nil (Unrecognised Status)",
          patent_status_id: 1,
        },
        { patent_status_name: "Pending", patent_status_id: 2 },
        { patent_status_name: "Registered", patent_status_id: 3 },
        { patent_status_name: "Renewal Pending", patent_status_id: 5 },
        { patent_status_name: "Closed", patent_status_id: 6 },
      ],
      itemdata: {
        international_filing_number: "",
        international_filing_date: null,
        tm_type: 0,
        file_no: "",
        title: "",
        name_of_client: "",
        app_no: "",
        patent_no: "",
        city: "",
        owner_contact: 0,
        agent_contact: 0,
        associate_contact: 0,
        val_no: "",
        page_no: "",
        priority_number: "",
        status: 0,
        type: "",
        sub_type: "",
        remark: "",
        dead_last_annuity_paid: "",
        client_ref: "",
        good_service: "",
        registration_condition: "",
        owner_address: "",
        agent_address: "",
        associate_address: "",
        date_of_patent: null,
        date_of_application: null,
        date_of_publishing: null,
        date_of_examination: null,
        next_renewal: null,
        last_renewal_att: null,
        next_deadline: null,
        exam_request_deadline: null,
        exam_request_date: null,
        next_annuity_date: null,
        final_due_date_for_next_payment: null,
        last_annuity_paid: null,
      },
      headers: [
        {
          text: "Work Type",
          align: "left",
          // sortable: false,
          value: "documenttype_code",
          width: "10%",
          divider: true,
        },
        // {
        //   text: "Doc Type",
        //   align: "left",
        //   // sortable: false,
        //   value: "documenttype_actions_showdata",
        //   width: "10%",
        //   divider: true,
        // },
        {
          text: "File No.",
          align: "left",
          // sortable: false,
          value: "refno",
          divider: true,
        },

        // { text: "Date Create", value: "show_date", divider: true },
        { text: "Application No.", value: "app_no", divider: true },
        { text: "Client Name", value: "trademark_name", divider: true },
        { text: "Receive Date", value: "receive_date_show", divider: true },
        { text: "Deadline Date", value: "dead_line", divider: true },
        { text: "Last Update By", value: "display_name", divider: true },
        // { text: "Page No", value: "", divider: true },
        // { text: "Version", value: "", divider: true },
        // { text: "Lawyer", value: "lower", divider: true },
        { text: "Status", value: "show_status", divider: true },
        {
          text: "",
          value: "actions",
          width: "15%",
          align: "center",
          divider: true,
        },
      ],
      headersFile: [
        {
          text: "File",
          align: "left",
          // sortable: false,
          value: "file_name",
          divider: true,
        },
        {
          text: "Date Upload",
          align: "left",
          value: "update_date",
          divider: true,
        },
      ],
      FlieArray: [],
      dialogTimeline: false,
      disabled_status: false,
    };
  },
  async mounted() {
    await this.loadCustomerComboboxMetter();
    await this.loaddataobjecttypeBygroupId();
    await this.loaddatacontactByContact_type_owner();
    await this.loaddatacontactByContact_type_agent();
    await this.loaddatacontactByContact_type_associate();
    await this.loaddatacountry();
    await this.loaddata();
    await this.loaddataPriority();
    await this.loadshowTimeline();
    await this.loadfilecer();
    this.$hideLoader();
  },
  methods: {
    //onChanege customer filter full_address by id
    async onSelectComboboxMetterChange(value) {
      // console.log(`onSelectComboboxMetterChange: ${value}`);
      // console.log(`customer_list:${JSON.stringify(this.customer_list)}`);

      const selectedCustomer = this.customer_list.find(
        (customer) => customer.id === value
      );
      this.customer_address = selectedCustomer
        ? selectedCustomer.full_address
        : "";
    },
    async loadCustomerComboboxMetter() {
      const result = await api.getCustomerComboboxByMetter(
        localStorage.getItem(server.COMPANYID)
      );
      // console.log(`loadCustomerComboboxMetter: ${JSON.stringify(result.data)}`);

      this.customer_list = result.data;
    },
    editItemtimeline(item) {
      const url = `/appointment-patent-edit/${item.appointment_id}`; // หรือใส่ query ?file_no=xxx
      window.open(url, "_blank"); // เปิดหน้าใหม่
    },
    async loadfilecer() {
      try {
        const data_search = {
          tbl_name: "masterpt_cer",
          tbl_id: Number(this.main_id),
        };

        const res_cer = await api.getAllFileAtLawFile({ params: data_search });

        this.filename_cer = [];
        this.image_list_cer = [];
        this.getpreview_list_cer = [];
        this.preview_list_cer = [];
        this.removed_cer_files = []; // <<<< ประกาศไว้ตั้งต้น

        for (const file of res_cer.data) {
          this.filename_cer.push({
            name: file.file_name,
            checktypefile: "oldfile",
            id: file.id,
            update_date: file.update_date,
          });

          const fileUrl = `${filemasterPTUrl}/${this.$route.params.masterpt_id}/${file.file_name}`;
          this.image_list_cer.push({
            name: file.file_name,
            url: fileUrl,
            id: file.id,
            checktypefile: "oldfile",
          });
        }

        this.preview_list2_cer = this.preview_list_cer;
        this.checkfileeadd_cer = true;
      } catch (err) {
        console.error("Error loading cer files:", err);
      }
    },
    generateUniqueFileName(originalName) {
      let newName = originalName;
      let nameIndex = 1;

      // รวมชื่อไฟล์ทั้งหมด
      const currentNames = [
        ...this.filename.map((f) => (typeof f === "string" ? f : f.name)),
        ...this.filename_cer.map((f) => (typeof f === "string" ? f : f.name)),
        ...this.filenameedit.map((f) => (typeof f === "string" ? f : f.name)),
      ];

      // ถ้าชื่อซ้ำให้เพิ่ม _1 _2 ...
      while (currentNames.includes(newName)) {
        const dotIndex = originalName.lastIndexOf(".");
        if (dotIndex !== -1) {
          newName = `${originalName.substring(
            0,
            dotIndex
          )}-${nameIndex}${originalName.substring(dotIndex)}`;
        } else {
          newName = `${originalName}-${nameIndex}`;
        }
        nameIndex++;
      }

      return newName;
    },

    async previewMultiImageEdit(event) {
      var getnamedata = [];
      this.filenameedit = [];
      var input = event.target;
      var count = input.files.length;
      var index = 0;
      if (input.files) {
        while (count--) {
          var reader = new FileReader();
          reader.onload = (e) => {
            this.getpreview_listedit.push(e.target.result);
            this.preview_listedit.push(e.target.result);
          };
          if (input.files[index].type === "application/pdf") {
            getnamedata.push(input.files[index]);
            reader.readAsDataURL(input.files[index]);
          }
          index++;
        }
      }

      await this.getPdf(this.getpreview_listedit, "newfile");
      this.preview_listedit2 = this.preview_listedit;

      getnamedata.forEach((x) => {
        let originalName = x.name;
        let name = originalName;
        let counter = 1;

        const existingNames = [
          ...this.filename.map((f) => f.name),
          ...this.filenameedit,
          ...this.filename_cer.map((f) => f.name), // เพิ่มเช็คชื่อไฟล์ cer ด้วย
        ];

        while (existingNames.includes(name)) {
          const dotIndex = originalName.lastIndexOf(".");
          if (dotIndex !== -1) {
            const basename = originalName.substring(0, dotIndex);
            const extension = originalName.substring(dotIndex);
            name = `${basename}-${counter}${extension}`;
          } else {
            name = `${originalName}-${counter}`;
          }
          counter++;
        }

        this.filename.push({ name: name, checktypefile: "newfile" });
        this.filenameedit.push(name);

        const renamedFile = new File([x], name, { type: x.type });
        this.image_listedit.push(renamedFile);
      });

      this.checkfileedit = true;
    },

    async previewMultiImage_cer(event) {
      var input_cer = event.target;
      var count_cer = input_cer.files.length;
      var index_cer = 0;

      if (input_cer.files) {
        while (count_cer--) {
          var reader_cer = new FileReader();
          reader_cer.onload = (e) => {
            this.getpreview_list_cer.push(e.target.result);
            this.preview_list_cer.push(e.target.result);
          };

          if (input_cer.files[index_cer].type === "application/pdf") {
            let originalFile = input_cer.files[index_cer];
            let newName = this.generateUniqueFileName(originalFile.name);

            let renamedFile = new File([originalFile], newName, {
              type: originalFile.type,
            });

            this.image_list_cer.push(renamedFile);
            this.filename_cer.push({ name: newName, checktypefile: "newfile" });

            reader_cer.readAsDataURL(renamedFile);
          }
          index_cer++;
        }
      }

      await this.getPdfforAdd_cer(this.getpreview_list_cer);
      this.preview_list2_cer = this.preview_list_cer;
      this.checkfileeadd_cer = true;
    },

    async popupdeletefile_cer(index) {
      this.fileindex_cer = index;
      this.dialogDelete_cer = true;
    },
    async closeDelete_cer() {
      this.fileindex_cer = -1;
      this.dialogDelete_cer = false;
    },
    async deleteItemConfirm_cer() {
      // กัน error
      if (this.fileindex_cer < 0) return;

      // --- เก็บชื่อไฟล์ที่จะลบ ---
      const removedFileName = this.filename_cer[this.fileindex_cer]?.name;
      if (
        removedFileName &&
        !this.removed_cer_files.includes(removedFileName)
      ) {
        this.removed_cer_files.push(removedFileName);
      }

      // --- ลบออกจากทุก list ---
      this.preview_list2_cer = [];
      this.getpreview_list_cer.splice(this.fileindex_cer, 1);
      this.image_list_cer.splice(this.fileindex_cer, 1);
      this.filename_cer.splice(this.fileindex_cer, 1);

      // --- รีโหลด PDF preview ---
      await this.getPdfforAdd_cer(this.getpreview_list_cer);

      this.preview_list2_cer = this.preview_list_cer;
      this.fileindex_cer = -1;
      this.dialogDelete_cer = false;
    },
    async popuppreviewfile_cer(fileindex) {
      this.previewpopupfile2 = [];

      // ถ้าไฟล์ index นี้เป็นไฟล์ใหม่ (ใน getpreview_list_cer)
      if (
        fileindex >=
        this.filename_cer.filter((f) => f.checktypefile === "oldfile").length
      ) {
        // คำนวณ index สำหรับไฟล์ใหม่ (เอา index ไฟล์เก่าออก)
        const indexNew =
          fileindex -
          this.filename_cer.filter((f) => f.checktypefile === "oldfile").length;

        let pdf_newTab = window.open("");
        pdf_newTab.document.write(
          `<html><head><title>pdf file</title></head><body><iframe title="MY title" width="100%" height="100%" src="${this.getpreview_list_cer[indexNew]}"></iframe></body></html>`
        );

        return;
      } else {
        // ไฟล์เก่า ใช้ url จาก image_list_cer ที่เก็บไว้
        const oldFiles = this.filename_cer.filter(
          (f) => f.checktypefile === "oldfile"
        );
        const fileName = oldFiles[fileindex].name;

        let pdf_newTab = window.open(
          `${filemasterPTUrl}/${this.$route.params.masterpt_id}/${fileName}`
        );

        return;
      }
    },
    async getPdfforAdd_cer(item_cer) {
      this.preview_list_cer = [];
      let getfile_cer = [];
      getfile_cer = item_cer;
      getfile_cer.forEach((file_cer, index_cer) => {
        this.preview_list_cer.push(pdfvuer.createLoadingTask(`${file_cer}`));
      });
      this.preview_list_cer.forEach((item_cer, index_cer) => {
        item_cer.then((pdf_cer) => {
          this.numPages_cer = pdf_cer.numPages;
          function changePage_cer() {
            var i_cer = 1,
              count_cer = Number(pdf_cer.numPages);
            do {
              if (
                window.pageYOffset >=
                this.findPos(document.getElementById(i_cer)) &&
                window.pageYOffset <=
                this.findPos(document.getElementById(i_cer + 1))
              ) {
                this.page_cer = i_cer;
              }
              i_cer++;
            } while (i_cer < count_cer);
            if (
              window.pageYOffset >= this.findPos(document.getElementById(i_cer))
            ) {
              this.page_cer = i_cer;
            }
          }
        });
      });
      this.checkfileadd_cer = true;
    },
    onApplicationDateChanged() {
      if (this.date_of_application) {
        if (
          this.itemdata.dead_last_annuity_paid != "" &&
          this.itemdata.dead_last_annuity_paid
        ) {
          const parts = this.date_of_application.split("-");
          const date = new Date(+parts[0], parts[1] - 1, +parts[2]);

          const yearsToAdd = Number(this.itemdata.dead_last_annuity_paid) - 1;

          const originalDay = date.getDate();
          date.setFullYear(date.getFullYear() + yearsToAdd);

          if (date.getDate() < originalDay) {
            date.setDate(0);
          }

          const y = date.getFullYear();
          const m = String(date.getMonth() + 1).padStart(2, "0");
          const d = String(date.getDate()).padStart(2, "0");

          this.itemdata.next_annuity_date = `${d}/${m}/${y}`;
          this.next_annuity_date = `${y}-${m}-${d}`;

          this.updateFinalDueDateFromNextAnnuity();
        }
      }
    },
    updateNextPaymentDueDate() { },
    updateFinalDueDateFromNextAnnuity() {
      var dateString = this.next_annuity_date;

      if (!dateString) return "";

      const [year, month, day] = dateString.split("-").map(Number);
      const date = new Date(year, month - 1, day); // สร้าง Date

      date.setDate(date.getDate() + 60); // บวก 60 วัน

      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");

      this.itemdata.final_due_date_for_next_payment = `${d}/${m}/${y}`;
    },
    addPriority() {
      this.priorityList.push({
        id: 0,
        number: "",
        date: "",
        country: "",
        menu: false,
      });
    },

    removePriority(index) {
      this.priorityList.splice(index, 1);
    },
    formatDatePriority(date) {
      if (!date) return "";
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDateInputPriority(value) {
      if (!value) return "";
      const parts = value.split("/");
      if (parts.length === 3) {
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
      }
      return value; // fallback ถ้า format ไม่ถูกต้อง
    },
    openTimeline() {
      this.dialogTimeline = true;
    },
    async popupdeletefile(index) {
      this.fileindex = index;
      this.dialogDelete = true;
    },
    async closeDelete() {
      this.fileindex = -1;
      this.dialogDelete = false;
    },
    async deleteItemConfirm() {
      // this.preview_listedit = [];
      this.filename.splice(this.fileindex, 1);
      this.preview_listedit2 = [];
      let index = this.fileindex - this.oldpdffiles.length;
      if (this.fileindex >= this.oldpdffiles.length) {
        this.getpreview_listedit.splice(index, 1);
        this.image_listedit.splice(index, 1);
        this.filenameedit.splice(index, 1);
      } else {
        this.getoldfilename.push(this.oldpdffiles[this.fileindex]);
        this.oldpdffiles.splice(this.fileindex, 1);
        this.getcurrentfilename = this.oldpdffiles;

        // await this.getPdf(this.oldpdffiles[fileindex], "oldfile");
      }

      await this.getPdf(this.getpreview_listedit, "newfile");

      this.preview_listedit2 = this.preview_listedit;
      this.fileindex = -1;
      this.dialogDelete = false;
    },
    async popupdeleteimage() {
      this.dialogDeleteimage = true;
    },
    async closeDeleteimage() {
      this.dialogDeleteimage = false;
    },
    async deleteItemConfirmimage() {
      this.checkimageedit = false;

      this.getoldimage = this.getcurrentimage;
      // this.getcurrentimage = "";
      this.previewimageedit = "";
      this.imageedit = null;
      this.imagenameedit = "";
      this.dialogDeleteimage = false;
    },
    async popuppreviewfile(fileindex) {
      this.previewpopupfile2 = [];

      let index = fileindex - this.oldpdffiles.length;
      if (fileindex >= this.oldpdffiles.length) {
        let pdf_newTab = window.open("");
        pdf_newTab.document.write(
          "<html><head><title>pdf file</title></head><body><iframe title='MY title'  width='100%' height='100%' src='" +
          this.getpreview_listedit[index] +
          "'></iframe></body></html>"
        );

        return;
        await this.getPdfforpreview(this.getpreview_listedit[index], "newfile");
      } else {
        let pdf_newTab = window.open(
          `${filemasterPTUrl}/${this.$route.params.masterpt_id}/${this.oldpdffiles[fileindex]}`
        );

        return;
      }
    },
    async closepreviewfile() {
      this.dialogpreviewfile = false;
    },
    async popuppreviewimage() {
      const imageTab = window.open("");
      imageTab.document.write(`
        <html>
          <head>
            <title>Preview Image</title>
          </head>
          <body style="margin:0; display:flex; flex-direction:column; justify-content:center; align-items:center; height:100vh; background-color:#000;">
            <img src="${this.previewimageedit}" alt="Preview" style="max-width:100%; max-height:100%; margin-bottom:20px;" />
          </body>
        </html>
      `);
      return;
    },
    async closepreviewimage() {
      this.dialogpreviewimage = false;
    },
    previewImageEdit: function (event) {
      var input = event.target;
      if (input.files) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.previewimageedit = e.target.result;
          this.checkimageedit = true;
        };
        this.imageedit = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
      this.getoldimage = this.getcurrentimage;
      this.imagenameedit = this.imageedit.name;
    },

    async getPdfforpreview(datafile, method) {
      this.previewpopupfile = [];
      let getfile = [];
      getfile = datafile;
      if (method == "oldfile") {
        this.previewpopupfile.push(
          pdfvuer.createLoadingTask(
            `${filemasterPTUrl}/${this.$route.params.masterpt_id}/${getfile}`
          )
        );
      } else {
        this.previewpopupfile.push(pdfvuer.createLoadingTask(`${getfile}`));
      }

      this.previewpopupfile.forEach((item, index) => {
        item.then((pdf) => {
          this.numPagespreview = pdf.numPages;
        });
      });
    },
    handle_pdf_link: function (params) {
      // Scroll to the appropriate place on our page - the Y component of
      // params.destArray * (div height / ???), from the bottom of the page div
      var page = document.getElementById(String(params.pageNumber));
      page.scrollIntoView();
    },
    async getPdf(item, method) {
      this.preview_listedit = [];
      let getfile = [];

      if (method == "newfile") {
        getfile = item;

        this.oldpdffiles.forEach((file, index) => {
          this.preview_listedit.push(
            pdfvuer.createLoadingTask(
              `${filemasterPTUrl}/${this.$route.params.masterpt_id}/${file}`
            )
          );
        });

        getfile.forEach((file, index) => {
          this.preview_listedit.push(pdfvuer.createLoadingTask(`${file}`));
        });
        this.preview_listedit.forEach((item, index) => {
          item.then((pdf) => {
            this.numPages = pdf.numPages;
          });
        });
      } else {
        if (item == "" || item == null) {
          this.checkfileedit = false;
        } else {
          getfile = item;
          getfile.forEach((file, index) => {
            this.preview_listedit.push(
              pdfvuer.createLoadingTask(
                `${filemasterPTUrl}/${this.$route.params.masterpt_id}/${file}`
              )
            );
          });

          this.preview_listedit.forEach((item, index) => {
            item.then((pdf) => {
              this.numPages = pdf.numPages;
              // window.onscroll = function() {
              //   changePage();
              //   stickyNav();
              // };

              // Get the offset position of the navbar
              // var sticky = $("#buttons")[0].offsetTop;

              // // Add the sticky class to the this.$refs.nav when you reach its scroll position. Remove "sticky" when you leave the scroll position
              // function stickyNav() {
              //   if (window.pageYOffset >= sticky) {
              //     $("#buttons")[0].classList.remove("hidden");
              //   } else {
              //     $("#buttons")[0].classList.add("hidden");
              //   }
              // }

              function changePage() {
                var i = 1,
                  count = Number(pdf.numPages);
                do {
                  if (
                    window.pageYOffset >=
                    this.findPos(document.getElementById(i)) &&
                    window.pageYOffset <=
                    this.findPos(document.getElementById(i + 1))
                  ) {
                    this.page = i;
                  }
                  i++;
                } while (i < count);
                if (
                  window.pageYOffset >= this.findPos(document.getElementById(i))
                ) {
                  this.page = i;
                }
              }
            });
          });
        }
        this.checkfileedit = true;
      }
    },
    findPos(obj) {
      return obj.offsetTop;
    },

    async loaddata() {
      if (this.$route.params.masterpt_id) {
        this.mode_operation = "Update";
        this.main_id = this.$route.params.masterpt_id;

        var data_search = {
          tbl_name: "masterpt",
          tbl_id: Number(this.main_id),
        };

        const result_file = await api.getAllFileAtLawFile({
          params: data_search,
        });

        var fileName = "";
        var imageName = "";

        if (result_file.data.length > 0) {
          this.FlieArray = result_file.data;
          for (const [index, item] of result_file.data.entries()) {
            if (item.file_type == "image") {
              if (imageName) imageName += `,`;
              imageName += item.file_name;
            } else {
              if (fileName) fileName += `,`;
              fileName += item.file_name;
            }
          }
        }

        const result = await api.getByIdMasterPT(this.main_id);

        if (result.data && result.data.length > 0) {
          if (result.data[0].master_images == "") {
            result.data[0].master_images = imageName;
          } else {
            let masterImages = result.data[0].master_images;
            // แยกค่าด้วยเครื่องหมายคอมม่า
            let imageArray = masterImages.split(",");

            // ตัดช่องว่างที่หน้าและหลังของแต่ละค่า
            imageArray = imageArray.map((image) => image.trim());

            // ถ้าคุณต้องการลบคอมม่าที่ท้ายสุด ถ้ามี
            if (imageArray[imageArray.length - 1] === "") {
              imageArray.pop(); // ลบค่าว่างที่เกิดจากคอมม่าที่ท้ายสุด
            }

            for (const [index, item] of imageArray.entries()) {
              var data_tableimage = {
                id: 0,
                tbl_name: "masterpt",
                tbl_id: this.main_id,
                file_type: "image",
                file_name: item,
                created_at: "",
                updated_at: "",
                update_date: "-",
              };
              this.FlieArray.push(data_tableimage);
            }

            if (imageName != "") {
              result.data[0].master_images =
                result.data[0].master_images + "," + imageName;
            }
          }
          if (result.data[0].master_files == "") {
            result.data[0].master_files = fileName;
          } else {
            let masterFile = result.data[0].master_files;
            // แยกค่าด้วยเครื่องหมายคอมม่า
            let fileArray = masterFile.split(",");

            // ตัดช่องว่างที่หน้าและหลังของแต่ละค่า
            fileArray = fileArray.map((image) => image.trim());

            // ถ้าคุณต้องการลบคอมม่าที่ท้ายสุด ถ้ามี
            if (fileArray[fileArray.length - 1] === "") {
              fileArray.pop(); // ลบค่าว่างที่เกิดจากคอมม่าที่ท้ายสุด
            }

            for (const [index, item] of fileArray.entries()) {
              var data_tablefile = {
                id: 0,
                tbl_name: "masterpt",
                tbl_id: this.main_id,
                file_type: "file",
                file_name: item,
                created_at: "",
                updated_at: "",
                update_date: "-",
              };
              this.FlieArray.push(data_tablefile);
            }

            if (fileName != "") {
              result.data[0].master_files =
                result.data[0].master_files + "," + fileName;
            }
          }

          const editItem = result.data;
          this.itemdata = editItem[0];
          this.itemdata.status = Number(editItem[0].status);

          const item = result.data[0];

          // load image //
          try {
            this.imagenameedit = item.master_images;
            this.filename = [];
            this.filenameedit = [];
            if (item.master_files == "" || item.master_files == null) {
              this.checkfileedit = false;
            } else {
              let getdata = item.master_files.split(",");
              getdata.forEach((x) => {
                this.filename.push({ name: x, checktypefile: "oldfile" });
              });
              this.oldfilename = this.filename;
              this.oldpdffiles = item.master_files.split(",");
              this.getcurrentfilename = this.oldpdffiles;

              await this.getPdf(this.oldpdffiles, "oldfile");
              this.preview_listedit2 = this.preview_listedit;
              this.checkfileedit = true;
            }
            this.getcurrentimage = item.master_images;
            this.previewimageedit = `${imagemasterPTUrl}/${item.masterpt_id}/${item.master_images}`;
            if (item.master_images == "" || item.master_images == null) {
              this.checkimageedit = false;
            } else {
              this.checkimageedit = true;
            }
          } catch (error) { }

          // load image //

          this.itemdata.date_of_application = this.formatDate(
            this.itemdata.date_of_application
          );

          this.date_of_application = this.parseDate(
            this.itemdata.date_of_application
          );
          this.itemdata.date_of_patent = this.formatDate(
            this.itemdata.date_of_patent
          );
          this.itemdata.date_of_publishing = this.formatDate(
            this.itemdata.date_of_publishing
          );
          this.itemdata.exam_request_date = this.formatDate(
            this.itemdata.exam_request_date
          );
          this.itemdata.exam_request_deadline = this.formatDate(
            this.itemdata.exam_request_deadline
          );
          this.itemdata.date_of_examination = this.formatDate(
            this.itemdata.date_of_examination
          );
          this.itemdata.next_deadline = this.formatDate(
            this.itemdata.next_deadline
          );
          this.itemdata.last_annuity_paid = this.formatDate(
            this.itemdata.last_annuity_paid
          );
          this.itemdata.next_annuity_date = this.formatDate(
            this.itemdata.next_annuity_date
          );
          this.itemdata.final_due_date_for_next_payment = this.formatDate(
            this.itemdata.final_due_date_for_next_payment
          );
          this.itemdata.next_renewal = this.formatDate(
            this.itemdata.next_renewal
          );
          this.itemdata.last_renewal_att = this.formatDate(
            this.itemdata.last_renewal_att
          );
          this.itemdata.international_filing_date = this.formatDate(
            this.itemdata.international_filing_date
          );
          this.sendBilling = this.itemdata.send_billing;
          this.sendBillingDetail = this.itemdata.send_billing_detail;

          this.customer_selected = this.itemdata.cus_billing_id;
          await this.onSelectComboboxMetterChange(this.customer_selected);

          if (this.itemdata.status == 6) {
            this.disabled_status = true;
          } else {
            this.disabled_status = false;
          }
          this.selectOwner(editItem[0].owner_contact);
          this.onSelectAgentChange(editItem[0].agent_contact);
          this.onSelectAssociateChange(editItem[0].associate_contact);
          this.loadAppointmentByfile_no(this.itemdata.file_no);
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "No Data",
            "text-h5 red--text text-center"
          );
          return;
        }
        if (
          this.itemdata.sub_type != "PARIS" &&
          this.itemdata.sub_type != "PCT" &&
          this.itemdata.sub_type != "" &&
          this.itemdata.sub_type
        ) {
          this.other_sub = this.itemdata.sub_type;
          this.itemdata.sub_type = "Other";
        }
      }

      this.timelineData = this.FlieArray;
    },

    async loaddataPriority() {
      const res_priority = await api.getAllMASTERPT_PRIORITY_BYID(
        Number(this.$route.params.masterpt_id)
      );
      if (res_priority.data.length > 0) {
        this.priorityList = [];
        this.priorityListOld = [];
        res_priority.data.forEach((item) => {
          this.priorityListOld.push(item.id);

          this.priorityList.push({
            id: item.id,
            number: item.priority_number,
            date:
              item.priority_date === "1970-01-01" ? null : item.priority_date,
            country: item.priority_country,
            menu: false,
          });
        });
      }
    },
    async loadAppointmentByfile_no(file_no) {
      this.mDataArrayappointment = [];
      const result = await api.getmasterptAllrecords({ file_no: file_no });
      if (result.data && result.data.length > 0) {
        result.data.forEach((x, i) => {
          this.mDataArrayappointment.push(x);
          x.show_status = "";
          if (x.cert && x.cert == 1) {
            if (x.show_status == "") {
              x.show_status = "Pending";
            }
          }
          if (x.report && x.report == 1) {
            if (x.show_status == "") {
              x.show_status = "Report";
            } else {
              x.show_status += " / Report";
            }
          }
          if (x.done && x.done == 1) {
            if (x.show_status == "") {
              x.show_status = "Complete";
            } else {
              x.show_status += " / Complete";
            }
          }
          if (JSON.parse(x.documenttype_actions).length > 0) {
            x.documenttype_actions_showdata = "";
            x.documenttype_actions_showdata = JSON.parse(x.documenttype_actions)
              .map((item) => item.name)
              .join(", ");
          }
        });
        if (
          !this.mDataArrayappointment[0].documenttype_code &&
          this.mDataArrayappointment.length == 1
        ) {
          this.mDataArrayappointment = [];
        }
      } else {
        this.disablebtnappointmentallrecord = true;
      }
    },
    async loaddataobjecttypeBygroupId() {
      const result = await api.getObjectTypeByGroupId(2);
      this.objecttype_list = result.data;
    },
    async loaddatacontactByContact_type_owner() {
      const result = await api.getContactByContactType(1);
      this.contact_owner_list = result.data;
    },
    async loaddatacontactByContact_type_agent() {
      const result = await api.getContactByContactType(2);
      this.contact_agent_list = result.data;
    },
    async loaddatacontactByContact_type_associate() {
      const result = await api.getContactByContactType(3);
      this.contact_associate_list = result.data;
    },
    async loaddatacountry() {
      const result = await api.getAllCountry();
      this.country_list = result.data;
    },

    async saveItem(mode) {
      if (this.itemdata.sub_type != "") {
        if (this.itemdata.sub_type == "Other") {
          this.itemdata.sub_type = this.other_sub;
        } else {
          this.itemdata.sub_type = this.itemdata.sub_type;
        }
      }
      if (this.itemdata.tm_type == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Select Object Type",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (!this.itemdata.file_no) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Enter File No.",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.owner_contact_list.length == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Enter Client Name",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.itemdata.sub_type != "" && this.itemdata.sub_type == "PCT") {
        if (this.itemdata.international_filing_number == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please Enter International Filing Number",
            "text-h5 red--text text-center"
          );
          return;
        }
        if (!this.itemdata.international_filing_date) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please Enter International Filing Date",
            "text-h5 red--text text-center"
          );
          return;
        }
      }


      var contact_id = this.owner_contact_list
        .map((item) => item.contact_id)
        .join(",");
      this.itemdata.owner_contact = contact_id;

      if (this.mode_operation == "Update") {
        this.itemdata.date_of_application = this.changeformatDatetoinsert(
          this.itemdata.date_of_application
        );
        this.itemdata.date_of_patent = this.changeformatDatetoinsert(
          this.itemdata.date_of_patent
        );
        this.itemdata.date_of_publishing = this.changeformatDatetoinsert(
          this.itemdata.date_of_publishing
        );
        this.itemdata.exam_request_date = this.changeformatDatetoinsert(
          this.itemdata.exam_request_date
        );
        this.itemdata.exam_request_deadline = this.changeformatDatetoinsert(
          this.itemdata.exam_request_deadline
        );
        this.itemdata.date_of_examination = this.changeformatDatetoinsert(
          this.itemdata.date_of_examination
        );
        this.itemdata.next_deadline = this.changeformatDatetoinsert(
          this.itemdata.next_deadline
        );
        this.itemdata.last_annuity_paid = this.changeformatDatetoinsert(
          this.itemdata.last_annuity_paid
        );
        this.itemdata.next_annuity_date = this.changeformatDatetoinsert(
          this.itemdata.next_annuity_date
        );
        this.itemdata.final_due_date_for_next_payment =
          this.changeformatDatetoinsert(
            this.itemdata.final_due_date_for_next_payment
          );
        this.itemdata.next_renewal = this.changeformatDatetoinsert(
          this.itemdata.next_renewal
        );
        this.itemdata.last_renewal_att = this.changeformatDatetoinsert(
          this.itemdata.last_renewal_att
        );

        //   this.$showLoader();

        let formData = new FormData();
        formData.append("send_billing", this.sendBilling);
        if (this.sendBilling == "Reply All") {
          formData.append("send_billing_detail", "");
        } else {
          formData.append("send_billing_detail", this.sendBillingDetail);
        }
        if (this.getoldimage) {
          formData.append(`getoldimage`, this.getoldimage);
        } else {
          formData.append(`getcurrentimage`, this.getcurrentimage);
        }
        if (this.imageedit) {
          formData.append(`file`, this.imageedit);
        }

        this.image_listedit.forEach((x, index) => {
          formData.append(`file`, x);
        });

        if (
          this.getoldfilename &&
          this.getoldfilename != null &&
          this.getoldfilename != ""
        ) {
          formData.append("getoldfilename", this.getoldfilename);
        }

        if (
          this.getcurrentfilename &&
          this.getcurrentfilename != null &&
          this.getcurrentfilename != ""
        ) {
          formData.append("getcurrentfilename", this.getcurrentfilename);
        }

        formData.append("tm_type", this.itemdata.tm_type);
        formData.append("file_no", this.itemdata.file_no);
        formData.append("title", this.itemdata.title);

        const name_of_client = this.owner_contact_list
          .map((item) => item.contact_name)
          .join(", ");
        formData.append("name_of_client", name_of_client);

        formData.append("app_no", this.itemdata.app_no);
        formData.append("patent_no", this.itemdata.patent_no);
        formData.append("city", this.itemdata.city);

        if (this.itemdata.owner_contact) {
          formData.append("owner_contact", this.itemdata.owner_contact);
        }

        if (this.itemdata.agent_contact) {
          formData.append("agent_contact", this.itemdata.agent_contact);
        }

        if (this.itemdata.associate_contact) {
          formData.append("associate_contact", this.itemdata.associate_contact);
        }
        formData.append(
          "update_by",
          Number(localStorage.getItem(server.USER_ID))
        );
        formData.append("val_no", this.itemdata.val_no);
        formData.append("page_no", this.itemdata.page_no);
        formData.append("priority_number", this.itemdata.priority_number);
        formData.append("status", this.itemdata.status);
        formData.append("type", this.itemdata.type);
        formData.append("sub_type", this.itemdata.sub_type);

        if (this.itemdata.sub_type != "" && this.itemdata.sub_type == "PCT") {
          formData.append(
            "international_filing_number",
            this.itemdata.international_filing_number
          );
          formData.append(
            "international_filing_date",
            this.international_filing_date
          );
        } else {
          formData.append("international_filing_number", "");
          formData.append("international_filing_date", "");
        }
        formData.append("remark", this.itemdata.remark);
        formData.append(
          "dead_last_annuity_paid",
          this.itemdata.dead_last_annuity_paid
        );
        formData.append("client_ref", this.itemdata.client_ref);
        formData.append("good_service", this.itemdata.good_service);
        formData.append(
          "registration_condition",
          this.itemdata.registration_condition
        );
        formData.append("owner_address", this.itemdata.owner_address);
        formData.append("agent_address", this.itemdata.agent_address);
        formData.append("associate_address", this.itemdata.associate_address);
        if (this.itemdata.date_of_patent) {
          formData.append("date_of_patent", this.itemdata.date_of_patent);
        }
        if (this.itemdata.date_of_application) {
          formData.append(
            "date_of_application",
            this.itemdata.date_of_application
          );
        }

        if (this.itemdata.date_of_publishing) {
          formData.append(
            "date_of_publishing",
            this.itemdata.date_of_publishing
          );
        }

        if (this.itemdata.date_of_examination) {
          formData.append(
            "date_of_examination",
            this.itemdata.date_of_examination
          );
        }

        if (this.itemdata.next_renewal) {
          formData.append("next_renewal", this.itemdata.next_renewal);
        }

        if (this.itemdata.last_renewal_att) {
          formData.append("last_renewal_att", this.itemdata.last_renewal_att);
        }

        if (this.itemdata.next_deadline) {
          formData.append("next_deadline", this.itemdata.next_deadline);
        }

        if (this.itemdata.exam_request_deadline) {
          formData.append(
            "exam_request_deadline",
            this.itemdata.exam_request_deadline
          );
        }

        if (this.itemdata.exam_request_date) {
          formData.append("exam_request_date", this.itemdata.exam_request_date);
        }

        if (this.itemdata.next_annuity_date) {
          formData.append("next_annuity_date", this.itemdata.next_annuity_date);
        }
        if (this.itemdata.final_due_date_for_next_payment) {
          formData.append(
            "final_due_date_for_next_payment",
            this.itemdata.final_due_date_for_next_payment
          );
        }

        if (this.itemdata.last_annuity_paid) {
          formData.append("last_annuity_paid", this.itemdata.last_annuity_paid);
        }

        if (this.customer_selected) {
          formData.append("cus_billing_id", this.customer_selected);
        } else {
          formData.append("cus_billing_id", null);
        }
        this.$showLoader();
        const update_masterpt = await api.updateMasterPt_V2(
          this.main_id,
          formData
        );

        await api.AppointmentUpdateclientname(this.itemdata.file_no, {
          trademark_name: this.itemdata.name_of_client,
        });

        if (update_masterpt.status == 203) {
          this.$hideLoader();
          if (update_masterpt.data.file_no) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "data duplicate ",
              "please check File No.",
              "text-h5 red--text text-center"
            );
            return;
          }
          if (update_masterpt.data.app_no) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "data duplicate ",
              "please check Application No.",
              "text-h5 red--text text-center"
            );
            return;
          }
        }
        if (update_masterpt.status == 200 || update_masterpt.status == 201) {

          const removedFilesList = this.removed_cer_files || [];

          const existingFilesToKeep = this.filename_cer
            .filter(
              (f) =>
                f.checktypefile === "oldfile" &&
                !removedFilesList.includes(f.name)
            )
            .map((f) => f.name);

          const newFiles = this.image_list_cer.filter(
            (file) => !file.checktypefile || file.checktypefile === "newfile"
          );

          // สร้าง FormData
          var formDataCer = new FormData();

          newFiles.forEach((file) => {
            formDataCer.append("file", file); // ชื่อ 'file' ต้องตรงกับ multer config
          });

          const fileNames = newFiles.map((file) => file.name).join(",");
          formDataCer.append("file_cer", fileNames);
          formDataCer.append("removed_files", removedFilesList.join(","));

          const res = await api.update_cer_edit(this.main_id, formDataCer);

          if (this.itemdata.status == 6) {
            var res_clsed = await api.updateCloseApp(this.itemdata.file_no);
          }
          for (const [index, item] of this.priorityList.entries()) {
            if (item.id == 0) {
              var data_add_riority = {
                masterpt_id: this.main_id,
                priority_number: item.number,
                priority_date: item.date,
                priority_country: item.country,
              };

              if (item.number != "" || item.date != "" || item.country != "") {
                await api.createMASTERPT_PRIORITY(data_add_riority);
              }
            } else {
              var data_update_riority = {
                priority_number: item.number,
                priority_date: item.date,
                priority_country: item.country,
              };

              if (item.number != "" || item.date != "" || item.country != "") {
                await api.updateMASTERPTPRIORITY(item.id, data_update_riority);
              }
            }
          }
          if (this.priorityListOld.length > 0) {
            const notFoundIds = this.priorityListOld.filter(
              (id) => !this.priorityList.some((item) => item.id === id)
            );
            for (const [index, item] of notFoundIds.entries()) {
              await api.deleteMASTERPTPRIORITY(item);
            }
          }

          let dataAdd = {
            user_id: localStorage.getItem(server.USER_ID),
            log_in_out_id: localStorage.getItem(server.LOGIN_ID),
            action: "Create",
            table_name: "masterpt",
            table_id: this.main_id,
            date: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
          };

          await api.addTransectionLog(dataAdd);

          var dataEditLog = {
            last_update: moment()
              .tz("Asia/Bangkok")
              .format("YYYY-MM-DD HH:mm:ss"),
          };
          await api.updateLogInOutLog(
            localStorage.getItem(server.LOGIN_ID),
            dataEditLog
          );

          this.$hideLoader();

          if (mode == "createAp") {
            this.$store.state.global_push_dialog = true;
            this.setupAlertDialogPush(
              true,
              "save data",
              "save data success",
              "text-h5 green--text text-center",
              `/appointment-patent-new/${this.itemdata.file_no}`
            );
          } else {
            this.$store.state.global_push_dialog = true;
            this.setupAlertDialogPush(
              true,
              "save data",
              "save data success",
              "text-h5 green--text text-center",
              "/master-patent-list"
            );
          }
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "save data",
            "can't save data",
            "text-h5 red--text text-center"
          );
        }
      }
      //this.$hideLoader();
    },

    selectOwner(id) {
      const idList = id.split(",").map((x) => x.trim());

      const foundList = this.contact_owner_list.filter((item) =>
        idList.includes(String(item.contact_id))
      );

      this.owner_contact_list = foundList;

      this.onSelectOwnerChange();
    },
    async onSelectOwnerChange() {
      if (this.owner_contact_list.length > 0) {
        for (const [index, item] of this.owner_contact_list.entries()) {
          item.owner_address =
            item.address + " " + item.city + " " + item.country;
        }
      }
      //alert(id);
      // this.contact_owner_list.filter((item) => {
      //   if (item.contact_id == id) {
      //     this.owner_address =
      //       item.address + " " + item.city + " " + item.country;
      //     return item;
      //   }
      // });
    },
    async onSelectAgentChange(id) {
      let setdata;
      setdata = this.contact_agent_list.filter((item) => {
        if (item.contact_id == id) {
          console.log(item);
          this.itemdata.agent_email = item.email;
          this.agent_address =
            item.address + " " + item.city + " " + item.country;
          return item;
        }
      });
    },
    async onSelectAssociateChange(id) {
      this.contact_associate_list.filter((item) => {
        if (item.contact_id == id) {
          this.associate_address =
            item.address + " " + item.city + " " + item.country;
          return item;
        }
      });
    },
    changeformatDatetoinsert(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("/");
      return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
    },

    async popuppreviewImageTable(filename) {
      const imageTab = window.open("");
      imageTab.document.write(`
        <html>
          <head>
            <title>Preview Image</title>
          </head>
          <body style="margin:0; display:flex; flex-direction:column; justify-content:center; align-items:center; height:100vh; background-color:#000;">
            <!-- แสดงภาพที่นี่ -->
            <img src="${imagemasterPTUrl}/${this.$route.params.masterpt_id}/${filename}" alt="Preview" style="max-width:100%; max-height:100%; margin-bottom:20px;" />
            
          </body>
        </html>
      `);
      return;
    },
    async popuppreviewfileTable(filename) {
      let pdf_newTab = window.open(
        `${filemasterPTUrl}/${this.$route.params.masterpt_id}/${filename}`
      );

      return;
    },
    async loadshowTimeline() {
      this.showtimelineData = [];
      this.$showLoader();

      const result = await api.gettimelinemasterpt({
        masterpt_id: this.$route.params.masterpt_id,
      });

      if (result.data && result.data.length > 0) {
        result.data.forEach((x, i) => {
          const isAnnuity = (x.documenttype_code || "").includes(
            "Annuity Fees"
          );

          if (isAnnuity) {
            x.show_date = `Last Annuity Payment - ${x.last_annuity} (Year)`;
            x.date_sort = x.last_annuity;
          } else if (x.documenttype_code === "New Filing") {
            x.show_date = `Application Date - ${x.application_date}`;
            x.date_sort = x.application_date;
          } else {
            x.show_date = `Submitted Date - ${x.submit_date}`;
            x.date_sort = x.submit_date;
          }

          this.showtimelineData.push(x);

          // parse JSON ก่อน แล้วเช็กว่ามีข้อมูลจริง
          let changeData = [];
          try {
            changeData = JSON.parse(x.change_master_record_data_All) || [];
          } catch (e) {
            changeData = [];
          }

          if (changeData.length > 0) {
            x.documenttype_code =
              changeData.map((item) => item.field_name).join(" / ") || "";
          }
          this.showtimelineData.sort((a, b) => {
            const aIsAnnuity = (a.documenttype_code || "").includes(
              "Annuity Fees"
            );
            const bIsAnnuity = (b.documenttype_code || "").includes(
              "Annuity Fees"
            );

            // กลุ่ม if มาก่อน else
            if (aIsAnnuity && !bIsAnnuity) return -1;
            if (!aIsAnnuity && bIsAnnuity) return 1;

            // ถ้าอยู่ในกลุ่มเดียวกัน
            if (aIsAnnuity) {
              // เรียงตามตัวเลขมากไปน้อย
              return Number(b.date_sort) - Number(a.date_sort);
            } else {
              // แปลงวันที่ dd/mm/yyyy เป็น Date object แล้วเรียงมากไปน้อย
              const parseDate = (d) => {
                if (!d || typeof d !== "string") return new Date(0); // ถ้า null, undefined, หรือไม่ใช่ string ให้เป็นวันที่ต่ำสุด
                const parts = d.split("/");
                if (parts.length !== 3) return new Date(0); // ถ้ารูปแบบไม่ถูกต้อง
                const [day, month, year] = parts.map(Number);
                return new Date(year, month - 1, day);
              };
              return parseDate(b.date_sort) - parseDate(a.date_sort);
            }
          });
          // this.showtimelineData
        });
        if (
          !this.showtimelineData[0].documenttype_code &&
          this.showtimelineData.length == 1
        ) {
          this.showtimelineData = [];
        }
      }
      this.$hideLoader();
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    async openhideshowlistofrecord() {
      this.hideshowlistofrecord = !this.hideshowlistofrecord;
    },
    async openhideshowtimeline() {
      this.disablebtnappointmenttimeline = !this.disablebtnappointmenttimeline;
    },
    async openeditItemAppointment(appointment_id) {
      window.open(`/appointment-patent-edit/${appointment_id}`);
    },
  },
  beforeCreate() {
    this.$store.state.navMenu = true;
  },

  watch: {
    show: function (s) {
      if (s) {
        this.getPdf();
      }
    },
    page: function (p) {
      if (
        window.pageYOffset <= this.findPos(document.getElementById(p)) ||
        (document.getElementById(p + 1) &&
          window.pageYOffset >= this.findPos(document.getElementById(p + 1)))
      ) {
        // window.scrollTo(0,this.findPos(document.getElementById(p)));
        document.getElementById(p).scrollIntoView();
      }
    },
  },
  watch: {
    international_filing_date(val) {
      this.itemdata.international_filing_date = this.formatDate(
        this.international_filing_date
      );
    },
    date_of_application(val) {
      this.itemdata.date_of_application = this.formatDate(
        this.date_of_application
      );
    },
    date_of_patent(val) {
      this.itemdata.date_of_patent = this.formatDate(this.date_of_patent);
    },
    date_of_publishing(val) {
      this.itemdata.date_of_publishing = this.formatDate(
        this.date_of_publishing
      );
    },
    exam_request_date(val) {
      this.itemdata.exam_request_date = this.formatDate(this.exam_request_date);
    },
    exam_request_deadline(val) {
      this.itemdata.exam_request_deadline = this.formatDate(
        this.exam_request_deadline
      );
    },
    date_of_examination(val) {
      this.itemdata.date_of_examination = this.formatDate(
        this.date_of_examination
      );
    },
    next_deadline(val) {
      this.itemdata.next_deadline = this.formatDate(this.next_deadline);
    },
    last_annuity_paid(val) {
      this.itemdata.last_annuity_paid = this.formatDate(this.last_annuity_paid);
    },
    next_annuity_date(val) {
      this.itemdata.next_annuity_date = this.formatDate(this.next_annuity_date);
    },
    final_due_date_for_next_payment(val) {
      this.itemdata.final_due_date_for_next_payment = this.formatDate(
        this.final_due_date_for_next_payment
      );
    },
    next_renewal(val) {
      this.itemdata.next_renewal = this.formatDate(this.next_renewal);
    },
    last_renewal_att(val) {
      this.itemdata.last_renewal_att = this.formatDate(this.last_renewal_att);
    },
  },
};
</script>

<style scoped>
.text-left {
  color: aliceblue;
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred {
  background-color: #9e3b1b;
  color: white;
}

.v-autocomplete.v-input>.v-input__control>.v-input__slot {
  min-height: 10px;
}

.widthsizeformadvance {
  width: 60%;
}

.bd-block-tb {
  border-block: 1px solid gray;
  writing-mode: horizontal-tb;
  margin-left: 0%;
  margin-right: 0%;
  height: 45px;
}

.bd-block-lr {
  border-block: 1px solid gray;
  writing-mode: vertical-lr;
  margin-left: 0%;
  margin-right: 0%;
  height: 45px;
}

.widthsize80formadvance {
  width: 80%;
}

.heightsize55formadvance {
  height: 55px;
}

.heightsize80performadvance {
  height: 60%;
}

.heightsize90formadvance {
  height: 90px;
}

.heightsizemultiCo {
  height: 190px;
}

.heightsizemultiCo180 {
  height: 180px;
}

.heightsizemultiCo200 {
  height: 200px;
}

.widthsize8055formadvance {
  width: 80px;
  height: 55px;
}

.advance-text-height {
  height: 70px;
}

.some-other-style {
  background: blue;
}

.my-header-style {
  color: #ffffff !important;
  background: #515151;
}

.data-table-button {
  color: #9e3b1b;
}

.my-header2-style {
  color: #ffffff !important;
  background: #515151;
  width: 120px;
}

.my-header3-style {
  color: #ffffff !important;
  background: #515151;
  width: 80px;
}

.my-header4-style {
  color: #ffffff !important;
  background: #515151;
  width: 150px;
}

.btnuploadfile {
  border: 2px solid;
}

.widthbtnimagefile {
  width: 40%;
}

.widthsizesearch {
  width: 80px;
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.btnuploadfile {
  border: 2px solid;
}

h5 {
  color: #737373;
}

.vali {
  color: red;
}

h3 {
  font-size: 1.17em;
}

.file-link {
  cursor: pointer;
  color: blue;
  transition: color 0.2s ease;
}

.file-link:hover {
  color: gray;
}

.v-btn:not(.v-btn--round).v-size--default.buttongold {
  background-color: #464231;
  color: white;
}

.vali {
  color: red;
}

h3 {
  font-size: 1.17em;
}

.mt-h {
  margin-top: -25px;
}

.mt-hf {
  margin-top: -20px;
}

.mt-detail {
  margin-top: -16px;
}

.text-field-style {
  margin-top: -15px;
  margin-bottom: 22px;
  padding: 6px 10px;
  background-color: #f5f5f5;
  border: 1px solid #9e9e9e;
  border-radius: 4px;
  font-size: 14px;
  color: #a19898;
  min-height: 96px;
}

.scrollable-card {
  max-height: 185px;
  overflow-y: auto;
  overflow-x: hidden;
}

.v-btn:not(.v-btn--round).v-size--default.buttongold {
  background-color: #464231;
  color: white;
}

.bt-add {
  color: #1d88ac;
}

.bt-del {
  color: red;
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.btnuploadfile {
  border: 2px solid;
}

h5 {
  color: #737373;
}

.vali {
  color: red;
}

h3 {
  font-size: 1.17em;
}
</style>
